<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script></script>

<style lang="less">
@import './assets/base.css';
html,
body,
#app {
  height: 100%;
}
</style>
